import styled from "styled-components";

export const StyledDashboard = styled.main`
	animation: slideLeft 0.4s ease forwards;
`;
